// extracted by mini-css-extract-plugin
export default {"mainContainer":"BackArrow_mainContainer__XOfx9","backArrow":"BackArrow_backArrow__wfO3a","text":"BackArrow_text__j2GmH"};